import { legacyThemeId } from "../../../../../../shared/frontend/theme/themeRuntime";
import type { ThemeId } from "../../../../../../shared/frontend/theme/themeCatalog";

export type ThemeMode = "light" | "dark";
export type ThemeShape = "rounded" | "square";

/** Standard-Design von m1member, solange weder App noch Mandant etwas anderes vorgeben. */
export const memberDefaultThemeId: ThemeId = "noir-dark";

/** Feste Rundung der öffentlichen Widgets (eigener Designvertrag, siehe `createAntdTheme`). */
export const widgetShape: ThemeShape = "rounded";

/**
 * Feste Markenfarben von m1member für öffentliche Widgets (Buchung, Lead, Vertrag).
 * „Tinte · Signalgelb": hell ist Tinte die Hauptfarbe (Gelb wäre auf Weiß nicht lesbar), dunkel ist
 * es Signalgelb mit Tinte als Schrift darauf. Rot ist das Signal für Zähler.
 */
export const brandColors = {
  ink: "#111214",
  hivis: "#ffd60a",
  alarm: "#ff3b47",
} as const;

/** Hauptfarbe und Schrift auf der Hauptfarbe je Modus. */
export function brandPrimary(mode: ThemeMode): { color: string; onColor: string } {
  return mode === "dark" ? { color: brandColors.hivis, onColor: brandColors.ink } : { color: brandColors.ink, onColor: "#ffffff" };
}

/**
 * Frühere gerätelokale Benutzerwahl (Stil + Hell/Dunkel) bis 2026-10-13. Die frühere Vorgabe
 * Noir dunkel wurde für jeden Benutzer automatisch gespeichert und gilt deshalb nicht als eigene
 * Wahl — sonst würde sie den Standard von App und Mandant für alle verdecken.
 */
export function readLegacyMemberThemeId(accountId: string | null | undefined): ThemeId | null {
  if (!accountId) return null;
  try {
    const raw = localStorage.getItem(`m1member.theme.user.${accountId}`);
    if (!raw) return null;
    const legacy = JSON.parse(raw) as { mode?: unknown; style?: unknown };
    const id = legacyThemeId({ mode: legacy.mode, style: legacy.style ?? "noir" }, memberDefaultThemeId);
    return id === memberDefaultThemeId ? null : id;
  } catch {
    return null;
  }
}
